var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_8280",
    "data-name": "\\uADF8\\uB8F9 8280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_9167",
    "data-name": "\\uC0AC\\uAC01\\uD615 9167",
    width: 29,
    height: 29,
    fill: "#ff5f00"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_9166",
    "data-name": "\\uC0AC\\uAC01\\uD615 9166",
    width: 29,
    height: 29,
    fill: "#ff5f00",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8279",
    "data-name": "\\uADF8\\uB8F9 8279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8278",
    "data-name": "\\uADF8\\uB8F9 8278",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36936",
    "data-name": "\\uD328\\uC2A4 36936",
    d: "M23.985,27.2H6.666A1.418,1.418,0,0,1,5.25,25.782V9.666A1.418,1.418,0,0,1,6.666,8.25H23.985A1.418,1.418,0,0,1,25.4,9.666v8.058a.451.451,0,0,1-.9,0V9.666a.514.514,0,0,0-.514-.514H6.666a.514.514,0,0,0-.514.514V25.782a.514.514,0,0,0,.514.514H23.985a.514.514,0,0,0,.514-.514V23.74a.451.451,0,0,1,.9,0v2.043A1.418,1.418,0,0,1,23.985,27.2Z",
    transform: "translate(-2.092 -3.287)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36937",
    "data-name": "\\uD328\\uC2A4 36937",
    d: "M23.318,15.451a.451.451,0,0,1-.241-.07l-1.411-.894-1.412.894a.451.451,0,0,1-.482,0l-1.415-.894-1.414.894A.451.451,0,0,1,16.25,15V8.7a.451.451,0,0,1,.451-.451h6.617a.451.451,0,0,1,.451.451V15a.451.451,0,0,1-.451.451ZM18.357,13.5a.451.451,0,0,1,.241.07l1.415.894,1.412-.894a.451.451,0,0,1,.483,0l.96.608V9.153H17.152v5.029l.963-.609A.451.451,0,0,1,18.357,13.5Z",
    transform: "translate(-6.475 -3.288)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_421",
    "data-name": "\\uC120 421",
    d: "M-.3,3.16A.451.451,0,0,1-.75,2.709V-.3A.451.451,0,0,1-.3-.75.451.451,0,0,1,.152-.3V2.709A.451.451,0,0,1-.3,3.16Z",
    transform: "translate(7.517 13.533)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36938",
    "data-name": "\\uD328\\uC2A4 36938",
    d: "M12.137,23.445a.45.45,0,0,1-.319-.132l-.974-.974-.974.974a.451.451,0,0,1-.638-.638l1.293-1.293a.451.451,0,0,1,.638,0l1.293,1.293a.451.451,0,0,1-.319.77Z",
    transform: "translate(-3.626 -8.467)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_422",
    "data-name": "\\uC120 422",
    d: "M4.513.152H-.3A.451.451,0,0,1-.75-.3.451.451,0,0,1-.3-.75H4.513A.451.451,0,0,1,4.965-.3.451.451,0,0,1,4.513.152Z",
    transform: "translate(6.916 20.751)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_423",
    "data-name": "\\uC120 423",
    d: "M6.92.152H-.3A.451.451,0,0,1-.75-.3.451.451,0,0,1-.3-.75H6.92A.451.451,0,0,1,7.371-.3.451.451,0,0,1,6.92.152Z",
    transform: "translate(6.916 18.946)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36939",
    "data-name": "\\uD328\\uC2A4 36939",
    d: "M30.426,28.962a.749.749,0,0,1-.473-.169L26.4,25.907a1.642,1.642,0,0,1,0-2.551l3.553-2.885a.753.753,0,0,1,1.228.585v1.02h1.955a.451.451,0,1,1,0,.9H30.73a.451.451,0,0,1-.451-.451V21.369l-3.31,2.688a.74.74,0,0,0,0,1.15l3.31,2.688V26.737a.451.451,0,0,1,.451-.451h3.008a.451.451,0,0,1,0,.9H31.181v1.02a.747.747,0,0,1-.429.68A.755.755,0,0,1,30.426,28.962Z",
    transform: "translate(-10.277 -8.089)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36940",
    "data-name": "\\uD328\\uC2A4 36940",
    d: "M38.657,27.168H37.7a.451.451,0,1,1,0-.9h.956a1,1,0,0,0,1-1V22.151a1,1,0,0,0-1-1H37.7a.451.451,0,0,1,0-.9h.956a1.9,1.9,0,0,1,1.9,1.9v3.115A1.9,1.9,0,0,1,38.657,27.168Z",
    transform: "translate(-14.843 -8.069)",
    fill: "#ff5f00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.e25068e9c11074adca6654f311100091.svg";
export { ForwardRef as ReactComponent };